import React from 'react';
import { useAppSelector, useAppDispatch } from '../hooks';
import { selectUser,logout,logoutUser } from "../reducers/userSlice";
import { selectVM,turnOn, revert, changeVMID, changeVMOS, infectVM } from "../reducers/vmSlice";
import { Link } from "@chakra-ui/react";
import {
  Stack,
  Center,
  ButtonGroup,
  Heading,
  Button,
  Box,
  Flex,
  Text,
  useColorModeValue,
  Spacer,
  Image
} from "@chakra-ui/react";

export default function LoginButtons() {
    const user = useAppSelector(selectUser);
    const dispatch = useAppDispatch();

    const  logoutHandler = ()=>{
      // let token = JSON.stringify(localStorage.getItem("access_token"));
      // dispatch(logoutUser(token));
      dispatch(logout());
    }


    if (user.loggedIn === true){
        return (
            <Button
            fontSize={"lg"}
            fontWeight={600}
            color={"white"}
            bg={"red.500"}
            onClick={logoutHandler}>          Logout
          </Button>
        );
    }
    else {
    return (
        <>
            <Link href="/loginPage">
              <Button
                fontSize={"lg"}
                fontWeight={600}
                color={"white"}
                bg={"#211a52"}
              >
                Login
              </Button>
            </Link>
            <Link href="/signupPage">
              <Button
                fontSize={"lg"}
                fontWeight={600}
                color={"white"}
                bg={"#211a52"}
              >
                Signup
              </Button>
            </Link>
        </>
    );
      }


    }
    
